import React from "react";
import { Route, Switch } from "react-router-dom";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";

import DrugInteractionsDetailsLayout from "./DrugInteractionsDetailsLayout";
import DrugInteractionsLayout from "./DrugInteractionsLayout";
import MerativeAssistant from "../../components/MerativeAssistant";

const DrugInteractions = () => {
  const configData = useConfig();
  const applicationCode = configData?.productInfo?.applicationCode;
  return (
    <>
      {applicationCode !== "dmx" ? (
        <Switch>
          <Route
            path="/browse/drug-interactions"
            exact
            component={DrugInteractionsLayout}
          />
          <Route
            path="/browse/drug-interactions/:monographId"
            exact
            component={DrugInteractionsDetailsLayout}
          />
        </Switch>
      ) : (
        <Route path="/browse/drug-interactions" component={MerativeAssistant} />
      )}
    </>
  );
};

export default DrugInteractions;
